import {IconButton} from '@wandb/components';
import {Trigger as DropdownTrigger} from '@wandb/weave/components/DropdownMenu';
import clsx from 'clsx';
import React from 'react';

type RunRowHeaderMenuTriggerProps = {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  visible: boolean;
};

export function RowHeaderMenuTrigger(props: RunRowHeaderMenuTriggerProps) {
  const cls = clsx({
    'opacity-0': !props.visible,
    'transition-opacity duration-300': true,
  });

  return (
    <DropdownTrigger onClick={() => props.setMenuOpen(true)}>
      <div className={cls}>
        <IconButton
          icon="overflow-horizontal"
          aria-label="Show run menu"
          variant="ghost"
          isActive={props.menuOpen}
          onPress={e => {
            e.continuePropagation();
          }}
        />
      </div>
    </DropdownTrigger>
  );
}
